import { PromotionType } from '../graphQL/commons'
import { IPromotion } from '../interfaces'

export const deleteExcludedPromotionTypes = (
  promotions: IPromotion[],
  promotionsToExclude: PromotionType[],
): IPromotion[] =>
  promotions.filter(({ type }) => promotionsToExclude.indexOf(type) < 0)
